import React from "react";

import { ContentModuleBaseAttributes } from "utils/orm";

export interface RichTextBlock extends ContentModuleBaseAttributes {
    className?: string;
    richText: string;
}

const RichTextModule: React.FC<RichTextBlock> = (props) => {
    const { className, richText } = props;
    // eslint-disable-next-line react/no-danger
    return richText ? <div {...{ className }} dangerouslySetInnerHTML={{ __html: richText }} /> : null;
};
export { RichTextModule };
